// 高単価の新規A8案件。遷移先には withUtm を付けない（a8mat をそのまま渡す）。
// クリックは /api/track/click を経由し、許可したURLへだけリダイレクトする。

export const A8_CAMPAIGNS = {
  docomoHikari: {
    id: "docomo_hikari",
    name: "ドコモ光（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4AZA44+CU0E7M+50+54KL8Y",
    impression: "https://www15.a8.net/0.gif?a8mat=4AZA44+CU0E7M+50+54KL8Y",
  },
  wimax: {
    id: "wimax",
    name: "WiMAX（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4AZA44+CULTTE+50+3H3TCI",
    impression: "https://www12.a8.net/0.gif?a8mat=4AZA44+CULTTE+50+3H3TCI",
  },
  biglobeHikari: {
    id: "biglobe_hikari",
    name: "BIGLOBE光",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ6+G23X6A+B4+2N9KIA",
    impression: "https://www11.a8.net/0.gif?a8mat=4BEPQ6+G23X6A+B4+2N9KIA",
  },
  gmoHomeWifi: {
    id: "gmo_home_wifi",
    name: "ホームWi-Fi（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+1SBLE+50+7LVLZM",
    impression: "https://www19.a8.net/0.gif?a8mat=4BEPQ7+1SBLE+50+7LVLZM",
  },
  softbankHikariNext: {
    id: "softbank_hikari_next",
    name: "ソフトバンク光（NEXT）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+3KMEQ+348K+1BMW42",
    impression: "https://www10.a8.net/0.gif?a8mat=4BEPQ7+3KMEQ+348K+1BMW42",
  },
  gmoAuHikari: {
    id: "gmo_au_hikari",
    name: "auひかり（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ6+G2PCS2+50+64ALJM",
    impression: "https://www17.a8.net/0.gif?a8mat=4BEPQ6+G2PCS2+50+64ALJM",
  },
  auHikariNext: {
    id: "au_hikari_next",
    name: "auひかり（NEXT）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+4620I+348K+3H18R6",
    impression: "https://www14.a8.net/0.gif?a8mat=4BEPQ7+4620I+348K+3H18R6",
  },
  gmoSoftbankHikari: {
    id: "gmo_softbank_hikari",
    name: "ソフトバンク光（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+LGDU+50+740TK2",
    impression: "https://www16.a8.net/0.gif?a8mat=4BEPQ7+LGDU+50+740TK2",
  },
  softbankAirNext: {
    id: "softbank_air_next",
    name: "SoftBank Air（NEXT）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+5CX82+348K+2N9KIA",
    impression: "https://www15.a8.net/0.gif?a8mat=4BEPQ7+5CX82+348K+2N9KIA",
  },
  gmoSoftbankAir: {
    id: "gmo_softbank_air",
    name: "SoftBank Air（GMOとくとくBB）",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+LGDU+50+744OG2",
    impression: "https://www16.a8.net/0.gif?a8mat=4BEPQ7+LGDU+50+744OG2",
  },
  niftyHikari: {
    id: "nifty_hikari",
    name: "@nifty光",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+4RHMA+447K+BWVTE",
    impression: "https://www11.a8.net/0.gif?a8mat=4BEPQ7+4RHMA+447K+BWVTE",
  },
  otegaruHikari: {
    id: "otegaru_hikari",
    name: "おてがる光",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+A4E2A+4SHG+5YRHE",
    impression: "https://www17.a8.net/0.gif?a8mat=4BEPQ7+A4E2A+4SHG+5YRHE",
  },
  bbExciteHikari: {
    id: "bb_excite_hikari",
    name: "BB.excite光 MEC",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+8XIUQ+7JY+2N9KIA",
    impression: "https://www17.a8.net/0.gif?a8mat=4BEPQ7+8XIUQ+7JY+2N9KIA",
  },
  dtiHikari: {
    id: "dti_hikari",
    name: "DTI光",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+8C38Y+1QFI+354KNM",
    impression: "https://www18.a8.net/0.gif?a8mat=4BEPQ7+8C38Y+1QFI+354KNM",
  },
  eoHikari: {
    id: "eo_hikari",
    name: "eo光",
    href: "https://px.a8.net/svt/ejp?a8mat=4BEPQ7+2DR76+3IIQ+5YRHE",
    impression: "https://www16.a8.net/0.gif?a8mat=4BEPQ7+2DR76+3IIQ+5YRHE",
  },
  kuhon: {
    id: "kuhon",
    name: "KuHoN（北欧家具）",
    href: "https://px.a8.net/svt/ejp?a8mat=4B7YP1+EDDPGY+5HR6+5YJRM",
    impression: "https://www16.a8.net/0.gif?a8mat=4B7YP1+EDDPGY+5HR6+5YJRM",
  },
  kagu350: {
    id: "kagu350",
    name: "家具350",
    href: "https://px.a8.net/svt/ejp?a8mat=4B7YP1+ECS9V6+20EY+BWVTE",
    impression: "https://www12.a8.net/0.gif?a8mat=4B7YP1+ECS9V6+20EY+BWVTE",
  },
} as const;

export type A8CampaignKey = keyof typeof A8_CAMPAIGNS;
export type A8Campaign = (typeof A8_CAMPAIGNS)[A8CampaignKey];

const CAMPAIGN_BY_ID = new Map<string, A8Campaign>(
  Object.values(A8_CAMPAIGNS).map((campaign) => [campaign.id, campaign]),
);

export function isA8CampaignType(type: string | null): boolean {
  return !!type && CAMPAIGN_BY_ID.has(type);
}

/** type と url が許可リストの組と完全一致したときだけ、そのA8 URLを返す。 */
export function resolveA8Redirect(type: string | null, url: string | null): string | null {
  if (!type || !url) return null;
  const campaign = CAMPAIGN_BY_ID.get(type);
  if (!campaign || campaign.href !== url) return null;
  return campaign.href;
}

export function affiliateTrackPath(key: A8CampaignKey, placement: string): string {
  const campaign = A8_CAMPAIGNS[key];
  const params = new URLSearchParams({
    type: campaign.id,
    url: campaign.href,
    placement,
  });
  return `/api/track/click?${params.toString()}`;
}

export function clickRedirectTarget(input: {
  type: string | null;
  url: string | null;
  fallback: string;
}): string {
  if (isA8CampaignType(input.type)) {
    return resolveA8Redirect(input.type, input.url) ?? input.fallback;
  }
  return input.url || input.fallback;
}
